import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ManageBriefTabsService } from '../../service/manage-brief-tabs/manage-brief-tabs.service';
import { TiktokOneReportingService } from '../../../../services/tiktok-one-reporting/tiktok-one-reporting.service';
import { firstValueFrom } from 'rxjs';
import { LoadingInlineComponent } from '../../../../atoms/loading-inline/loading-inline.component';
import { FormatService } from '../../../../common/format/format.service';
import { TtoOverviewComponent } from './atoms/overview/overview';
import { TtoVideosComponent } from './atoms/videos/videos';
import { TtoCampaignVideoDto, TtoResultsDashboardEngagementsDto } from '@/app/common/general-types/tiktok-one-reporting.dto';


@Component({
  selector: 'mbt-reporting-tto',
  imports: [LoadingInlineComponent, TtoOverviewComponent, TtoVideosComponent],
  templateUrl: './reporting-tto.html',
  styleUrl: './reporting-tto.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ReportingTtoComponent implements OnInit {

  selectedTab = signal<'overview' | 'videos'>('overview');
  ttoCampaign = signal<{
    code: number,
    data?: {
      campaign_channel_type: string,
      campaign_id: string,
      campaign_type: string,
      page_info: {
        page: number,
        page_size: number,
        total_number: number,
        total_page: number,
      },
      tto_tcm_account_id: string,
      videos: TtoCampaignVideoDto[],
      message: string,
      request_id: string
    }
  } | undefined>(undefined);

  ttoEngagements = signal<{
    content_performance_data: {
      video_views: { total: number; organic: number; paid: number };
      average_view_time: { total: number; organic: number; paid: number };
      video_completion_rate: { total: number; organic: number; paid: number };
      two_second_video_views: { total: number; organic: number; paid: number };
      six_second_video_views: { total: number; organic: number; paid: number };
      video_views_by_source: Array<{ source: string; videoViews: number; percentage: number }>;
    },
    engagements_data: TtoResultsDashboardEngagementsDto,
    audience_data: {
      age_distribution: { age_group: string; percentage: number }[];
      countries_distribution: { country: string; percentage: number }[];
      device_distribution: { device: string; percentage: number }[];
      genders_distribution: { gender: string; percentage: number }[];
      language_distribution: { language: string; percentage: number }[];
      interest_distribution: { interest: string; percentage: number }[] | null;
    }
  } | undefined>(undefined);

  ttoLoadFailed = signal(false);

  private ttoTotalNumber = computed(() => this.ttoCampaign()?.data?.page_info?.total_number ?? 0);
  ttoVideos = computed(() => this.ttoCampaign()?.data?.videos ?? []);
  hasTtoResults = computed(() => !!this.ttoEngagements() && this.ttoTotalNumber() > 0);
  showTtoEmptyState = computed(() =>
    this.ttoLoadFailed() || (!!this.ttoCampaign() && (this.ttoTotalNumber() === 0 || this.ttoVideos().length === 0))
  );

  /** Services */
  private manageBriefTabsService = inject(ManageBriefTabsService);
  private ttoReportingService = inject(TiktokOneReportingService);
  public formatService = inject(FormatService);
  /** Services END */

  ngOnInit(): void {
    console.log('🚨 ReportingTto -> ngOnInit');
    this.getTtoReportingData();
    this.getTtoEngagementsDashboard();
  }

  async getTtoReportingData() {
    const tto_campaign_id = this.manageBriefTabsService.focussedBrief()?.shoutBrief?.ttoCampaignId;
    if (!tto_campaign_id) {
      return;
    }
    try {
      const ttoReportingData = await firstValueFrom(this.ttoReportingService.getIndividualPostResults(tto_campaign_id));
      console.log('🚨🚨🚨 111 getTtoReportingData: ', ttoReportingData);
      this.ttoCampaign.set(ttoReportingData);
    } catch (error) {
      console.error('Error getting TTO reporting data:', error);
      this.ttoLoadFailed.set(true);
    }
  }  

  async getTtoEngagementsDashboard() {
    const tto_campaign_id = this.manageBriefTabsService.focussedBrief()?.shoutBrief?.ttoCampaignId;
    if (!tto_campaign_id) {
      return;
    }
    try {
      const ttoResultsDashboard = await firstValueFrom(this.ttoReportingService.getTtoEngagementsDashboard(tto_campaign_id));
      console.log('🚨🚨🚨 222 getTtoEngagementsDashboard(): ', ttoResultsDashboard);
      this.ttoEngagements.set(ttoResultsDashboard);
    } catch (error) {
      console.error('Error getting TTO engagements dashboard:', error);
      this.ttoLoadFailed.set(true);
    }
  }

  getTabClass(tab: 'overview' | 'videos') {
    return this.selectedTab() === tab
      ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200'
      : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }

}
